import ApiService from './ApiService'

const CALCULATION_SEND_DATA = [
    'amount',
    'begin',
    'client_select',
    'consumable_cost',
    'discount',
    'duration',
    'monthly_utilization_plan',
    'billing_unit',
    'extra_price',
    'down_payment',
    'installation_fee',
    'maintenance',
    'maintenance_cost_show_as',
    'consumables_cost_show_as',
    'net_list_price',
    'currency_code',
    'preferred_number_format',
    'payment_per_piece_decimals',
    'residual_value',
    'revenue_per_wash',
    'transportation',
    'unit_country_id',
    'unit_type',
    'product_type',
]

const MONTHS_IN_YEAR = 12

const CafService = {
    calculate(inputs) {
        try {
            const cleanedInputs = CALCULATION_SEND_DATA.reduce((holder, key) => {
                holder[key] = inputs[key] === null ? 0 : inputs[key]

                if (key === 'unit_type') holder[key] = inputs[key]
                if (key === 'client_select') holder[key] = inputs[key]
                if (key === 'duration') holder[key] = inputs[key] * MONTHS_IN_YEAR
                if (key === 'residual_value') holder[key] = Number(inputs[key])

                return holder
            }, {})
            return ApiService.post('click_finance.calculate', cleanedInputs)
        } catch (error) {
            console.error('Error in CafService.calculate:', error)
            throw error
        }
    },

    getResidualValue(inputs) {
        const { duration, unit_type, product_type } = inputs

        const data = {
            product_type,
            months: duration * MONTHS_IN_YEAR,
        }

        if (inputs.expected_utilization) {
            data.annual_utilization = Array.isArray(inputs.expected_utilization)
                ? inputs.expected_utilization.reduce((sum, value) => sum + value, 0) / duration
                : inputs.expected_utilization
        }
        return ApiService.post('unit_type.residual_value', data, unit_type)
    },

    getItemList(route) {
        return ApiService.get(route, { page: -1 })
    },

    saveContract(inputs) {
        try {
            const cleanedInputs = CALCULATION_SEND_DATA.reduce((holder, key) => {
                holder[key] = inputs[key] === null ? 0 : inputs[key]

                if (key === 'unit_type') holder[key] = inputs[key]
                if (key === 'client_select') holder[key] = inputs[key]
                if (key === 'duration') holder[key] = inputs[key] * MONTHS_IN_YEAR
                if (key === 'residual_value') holder[key] = Number(inputs[key])

                return holder
            }, {})
            return ApiService.post('click_finance.store', cleanedInputs)
        } catch (error) {
            console.error('Error in CafService.saveContract:', error)
            throw error
        }
    },
}

export default CafService
